import { Grid, Widget } from '@revolut-internal/ui-kit'
import { Panel, PanelGroup } from 'react-resizable-panels'

import { NotFoundWidget } from 'components'
import { useProcessDebugDetailsContext } from 'pages/AiProcessDebugV2/hooks/useProcessDebugDetailsContext'
import { LocalStorageKeys } from 'lib/shared/consts'
import { ResizeHandle } from 'pages/AiProcessDebug/components/MessageDebug/ResizeHandle'

import { DebugDetails } from '../DebugDetails'
import { DebugMessages } from '../DebugMessages'

const PANEL_MIN_SIZE = 37.5

export const AiProcessDebugContent = () => {
  const { isLoadingDialogueSnapshots, chatMessages } = useProcessDebugDetailsContext()

  if (!isLoadingDialogueSnapshots && !chatMessages.length) {
    return <NotFoundWidget title="AI debug traces not found" />
  }

  return (
    <>
      <Grid height="calc(100vh - 100px)">
        <PanelGroup
          direction="horizontal"
          autoSaveId={LocalStorageKeys.PROCESS_DEBUG_CONTENT_PANELS}
        >
          <Panel minSize={PANEL_MIN_SIZE}>
            <Widget overflow="hidden" height="100%">
              <DebugMessages />
            </Widget>
          </Panel>
          <ResizeHandle />
          <Panel minSize={PANEL_MIN_SIZE}>
            <Widget overflow="hidden" height="100%" p="s-12">
              <DebugDetails />
            </Widget>
          </Panel>
        </PanelGroup>
      </Grid>
    </>
  )
}
